import React, { Component } from "react";

import "../style/style.css";
import _ from "lodash";
import moment from "moment";
import DefectReportView from "./DefectReportView";
import {
  assetTypesForIssues,
  assetTypeTracks,
  yardTypeATypeTracks,
  sidingAssetTypes,
} from "../../../../AssetTypeConfig/Reports/DefectReportConfig";
import { LocPrefixService } from "../../../LocationPrefixEditor/LocationPrefixService";
import { getIssueRemedialActionComments } from "../../utils/getIssueRemedialActionComments";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { languageService } from "../../../../Language/language.service";
import { unitMPMarkerItems, getIssueMPMethods } from "../../../Common/services/mileposts";

class DefectReport extends Component {
  constructor(props) {
    super(props);

    this.localState = {
      basicData: {},
      issuesData: [],
      assetsData: [],
      workOrderUpdates: [],
      staticMode: false,
    };

    this.calculateData(this.props.inspec);
    this.getGaugeValuesFromAppForms = this.getGaugeValuesFromAppForms.bind(this);
  }

  calculateData(journeyPlan) {
    let basicData = {};
    let issuesData = [];
    let sortedIssuesData;
    let assetIntervalList = [];
    let workOrderUpdates = [];
    let task = journeyPlan && journeyPlan.tasks && journeyPlan.tasks.length > 0 && journeyPlan.tasks[0];
    if (task) {
      basicData = this.basicDataMaker(task, journeyPlan);
      this.assetsAndIssuesData(journeyPlan, task, issuesData, assetIntervalList);
      sortedIssuesData = _.sortBy(issuesData, (issue) => {
        let start = issue.sortMP ? parseFloat(issue.sortMP) : 0;
        return start;
      });
      if (task.workOrderUpdates && task.workOrderUpdates.length) workOrderUpdates = task.workOrderUpdates.filter((wo) => wo.inspected);
    }

    this.localState = {
      basicData,
      issuesData: sortedIssuesData,
      assetsData: assetIntervalList,
      staticMode: true,
      rule213: true,
      workOrderUpdates: workOrderUpdates,
    };
  }
  getGaugeValuesFromAppForms(appforms) {
    let monthly = appforms.find((f) => f.id === "inspectionForm1" || f.id === "fixedInspectionForm1");
    let quarterly = appforms.find((f) => f.id === "inspectionForm2");

    const getFormatted = (form) => {
      if (!form || !form.form) return null;
      const num = form.form.find((f) => f.id === "widestGaugeNumber");
      const frac = form.form.find((f) => f.id === "widestGaugeFraction");
      const numVal = (num && num.value) || "";
      const fracVal = (frac && frac.value) || "";

      if (!numVal && !fracVal) return null;

      return `${numVal} ${fracVal}"`.trim();
    };

    const monthlyText = getFormatted(monthly);
    const quarterlyText = getFormatted(quarterly);
    let showNumber = monthlyText && quarterly;
    if (!monthlyText && !quarterlyText) return null;
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ textAlign: "left" }}>
          {monthlyText && (
            <div>
              <span style={{ width: "2ch" }}>{showNumber && "1:"}</span>
              <span>{monthlyText}</span>
            </div>
          )}
          {quarterlyText && (
            <div>
              <span style={{ width: "2ch" }}>{showNumber && "2:"}</span>
              <span>{quarterlyText}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  assetsAndIssuesData(journeyPlan, task, issuesData, assetIntervalList) {
    let intervals = !journeyPlan.intervals || journeyPlan.intervals.length <= 0 ? [] : _.cloneDeep(journeyPlan.intervals);
    let assetsData = [];
    let sidingAssetsAtTopSection = [];
    task.units.map((asset, count) => {
      const appFormsExists = Array.isArray(asset.appForms) && asset.appForms.length > 0;
      if (_.find(assetTypeTracks, (item) => asset.assetType === item)) {
        let assetData = {};
        assetData = { ...asset };
        assetData.HighRail = "";
        assetData.Walk = "";
        asset.Train = "";
        assetData.Observe = "";
        assetsData.push(assetData);
      }
      if (_.find(yardTypeATypeTracks, (item) => asset.assetType === item)) {
        if (appFormsExists) {
          let assetData = {};
          assetData = { ...asset };
          assetData.HighRail = task.traverseBy === "Hi-Rail" ? "X" : "";
          assetData.Walk = task.traverseBy === "Walking" || !task.traverseBy ? "X" : "";
          assetData.Train = task.traverseBy === "train" ? "X" : "";
          assetData.Observe = "";

          assetData.start = unitMPMarkerItems.getUnitMarkerMPStart(asset, journeyPlan.lineId);
          assetData.end = unitMPMarkerItems.getUnitMarkerMPEnd(asset, journeyPlan.lineId);
          assetData.sortMp = asset.start;

          // assetData.start = asset.startMarker && asset.startMarker.trim() ? asset.startMarker : startPrefix + asset.start;
          // assetData.end = asset.endMarker && asset.endMarker.trim() ? asset.endMarker : endPrefix + asset.end;
          assetIntervalList.push(assetData);
        }
      }
      if (_.find(sidingAssetTypes, (item) => asset.assetType === item)) {
        let fixedFormCodes = ["sidingInspectionForm1", "sidingInspectionForm2", "sidingInspectionForm3"];
        let foundAppForms = appFormsExists && asset.appForms.filter((af) => fixedFormCodes.find((c) => af && af.id === c));
        foundAppForms &&
          foundAppForms.forEach((foundAppForm) => {
            if (foundAppForm && foundAppForm.form && foundAppForm.form.length > 0) {
              let traversedObservedField = foundAppForm.form.find((field) => field && field.id === "psto");
              let traverseBy =
                traversedObservedField &&
                traversedObservedField.value === "Traverse" &&
                foundAppForm.form.find((field) => field && field.id === "travby");
              let observeValue = traversedObservedField && traversedObservedField.value === "Observe";
              let assetData = { ...asset };
              assetData.HighRail = traverseBy && traverseBy.value === "Hi-Rail" ? "X" : "";
              assetData.Walk = traverseBy && traverseBy.value === "Walking" ? "X" : "";
              assetData.Train = traverseBy && traverseBy.value === "Train" ? "X" : "";
              assetData.Observe = observeValue ? "X" : "";
              sidingAssetsAtTopSection.push(assetData);
            }
          });
      }
      let issues = _.filter(task.issues, (issueObj) => {
        return issueObj && issueObj.unit && issueObj.unit.id === asset.id;
      });
      if (appFormsExists) {
        if (issues && issues.length > 0) {
          issues.forEach((issue) => {
            // issuesIncluded.push(issue);
            this.issueDataMaker(issue, asset, issuesData, journeyPlan.lineId);
          });
        } else {
          let issueData = {};
          issueData.assetName = asset.unitId;
          issueData.sortMP = asset.start;
          issueData.MP = unitMPMarkerItems.getUnitMpMarkerValues(asset, journeyPlan.lineId);
          issueData.RemedialAction = languageService("No Exception Found");
          issueData.gaugeValue = this.getGaugeValuesFromAppForms(asset.appForms || []);
          issuesData.push(issueData);
        }
      } else {
        if (issues && issues.length > 0) {
          issues.forEach((issue) => {
            this.issueDataMaker(issue, asset, issuesData, journeyPlan.lineId);
          });
        }
      }
    });

    for (let session of intervals) {
      let intervalStart = parseFloat(session.start) < parseFloat(session.end) ? parseFloat(session.start) : parseFloat(session.end);
      let intervalEnd = parseFloat(session.start) > parseFloat(session.end) ? parseFloat(session.start) : parseFloat(session.end);
      if (session.hasOwnProperty("traversed") && session.hasOwnProperty("observed")) {
        let traversed = _.find(assetsData, { id: session.traversed });
        let observed = _.find(assetsData, { id: session.observed });
        if (traversed && considerAssetInInterval(traversed, intervalStart, intervalEnd)) {
          let asset = _.cloneDeep(traversed);
          asset.HighRail = task.traverseBy === "Hi-Rail" ? "X" : "";
          asset.Walk = task.traverseBy === "Walking" || !task.traverseBy ? "X" : "";
          asset.Train = task.traverseBy === "train" ? "X" : "";
          if (parseFloat(asset.start) < parseFloat(session.start)) asset.start = session.start;
          if (parseFloat(asset.end) > parseFloat(session.end)) asset.end = session.end;
          let startPrefix = LocPrefixService.getPrefixMp(asset.start, journeyPlan.lineId);
          let endPrefix = LocPrefixService.getPrefixMp(asset.end, journeyPlan.lineId);
          asset.start = startPrefix + asset.start;
          asset.end = endPrefix + asset.end;
          assetIntervalList.push(asset);
        }
        if (observed && considerAssetInInterval(observed, intervalStart, intervalEnd)) {
          let asset = _.cloneDeep(observed);
          asset.Observe = "X";
          if (parseFloat(asset.start) < parseFloat(session.start)) asset.start = session.start;
          if (parseFloat(asset.end) > parseFloat(session.end)) asset.end = session.end;
          let startPrefix = LocPrefixService.getPrefixMp(asset.start, journeyPlan.lineId);
          let endPrefix = LocPrefixService.getPrefixMp(asset.end, journeyPlan.lineId);
          asset.start = startPrefix + asset.start;
          asset.end = endPrefix + asset.end;
          assetIntervalList.push(asset);
        }
      } else {
        for (let asset of assetsData) {
          let assetToConsider = _.cloneDeep(asset);
          if (considerAssetInInterval(assetToConsider, intervalStart, intervalEnd)) {
            if (task.traverseTrack === asset.id) {
              assetToConsider.HighRail = task.traverseBy === "Hi-Rail" ? "X" : "";
              assetToConsider.Walk = task.traverseBy === "Walking" || !task.traverseBy ? "X" : "";
              assetToConsider.Train = task.traverseBy === "train" ? "X" : "";
            } else {
              assetToConsider.Observe = "X";
            }
            if (parseFloat(assetToConsider.start) < parseFloat(session.start)) assetToConsider.start = session.start;
            if (parseFloat(assetToConsider.end) > parseFloat(session.end)) assetToConsider.end = session.end;

            assetIntervalList.push(assetToConsider);
          }
        }
      }
    }
    sidingAssetsAtTopSection.forEach((sa) => assetIntervalList.push(sa));
  }
  issueDataMaker(issue, unit, issuesData, lineId) {
    let markerMpvValues = getIssueMPMethods.getIssueMPMarkerValue(issue, lineId);
    let startMpValue = getIssueMPMethods.getIssueFinalStartMP(issue, lineId, false);
    let issueData = {};
    // TODO check include deficiency report
    let serverObj = issue.serverObject ? issue.serverObject : {};
    let includeAllowedDeficiencies = true; //this.props.includeAllowedDeficiencies
    let includeDeficiencyCheck = includeAllowedDeficiencies && issue.issueType == "Deficiency" && serverObj.includeFRAReport;
    if (_.find(assetTypesForIssues, (item) => issue.unit.assetType === item) && (issue.issueType == "Defect" || includeDeficiencyCheck)) {
      issueData.assetName = issue.unit.unitId;
      let startPrefix = LocPrefixService.getPrefixMp(unit.start, lineId);
      let endPrefix = LocPrefixService.getPrefixMp(unit.end, lineId);
      issueData.startPrefix = startPrefix;
      issueData.endPrefix = endPrefix;
      issueData.MP = markerMpvValues;

      issueData.sortMP = startMpValue;
      issueData.Deficiency = issue.issueType == "Deficiency" ? true : "";
      issueData.FRADefect = issue.issueType == "Defect" ? true : "";
      if (issue.issueType == "Deficiency") {
        issueData.DefectDescription = issue.description;
      } else {
        let codeDescription = getCodeDescription(issue, this.props.nonFraCode);
        issueData.Code = codeDescription.majorDefectCode + codeDescription.minorDefectCode;
        issueData.DefectDescription = codeDescription.minorDescription;
      }
      issueData.RemedialAction = issue.remedialAction;
      issueData.rule213Applied = issue.ruleApplied ? issue.ruleApplied : "";

      issueData.timeStamp = moment(issue.timeStamp).format("MM/DD/YYYY");
      issueData.issueId = issue.issueId;
      issueData.comments = getIssueRemedialActionComments(issue);
      if (issue.serverObject) {
        issueData.repairDate =
          issue.serverObject.repairDate !== undefined ? moment(issue.serverObject.repairDate).format("MM/DD/YYYY") : "";
        if (issue.serverObject.repairedBy && this.props.usersSignatures && this.props.usersSignatures.length > 0) {
          let sig = _.find(this.props.usersSignatures, { email: issue.serverObject.repairedBy.email });
          let userName = issue.serverObject.repairedBy.name;
          if (sig && sig.signature) issueData.repairBySignature = sig.signature.imgName;
          if (userName) issueData.repairByName = issue.serverObject.repairedBy.name;
        }
        issueData.maintainerComments =
          issue.serverObject.maintainerComments && issue.serverObject.maintainerComments !== ""
            ? issue.serverObject.maintainerComments
            : null;
      }
      issueData.gaugeValue = this.getGaugeValuesFromAppForms(unit.appForms || []);
      issuesData.push(issueData);
    }
  }

  basicDataMaker(task, journeyPlan) {
    let basicData = {
      Date:
        typeof journeyPlan.date != "undefined" && journeyPlan.date != "null" && journeyPlan.date
          ? moment(journeyPlan.date).format("MM/DD/YYYY")
          : "",
      Line: typeof journeyPlan.lineName != "undefined" && journeyPlan.lineName != "null" ? journeyPlan.lineName : "",
      Weather: getWeather(task),
      InspectionWeekly: "",
      InspectionWeather: "",
      InspectionSpecial: "",
      Inspector: typeof journeyPlan.user.name != "undefined" && journeyPlan.user.name != "null" ? journeyPlan.user.name : "",
      InspectorId: typeof journeyPlan.user.id != "undefined" && journeyPlan.user.id != "null" ? journeyPlan.user.id : "",
      commentsDetail: task.inspectionTypeDescription,
      additionalComments: ReportGeneratorUtils.getAdditionalComments(journeyPlan),
    };
    basicData.Line = task.units && task.units.length > 0 && task.units[0].unitId;
    if (task.inspectionTypeTag == "special") {
      basicData.InspectionSpecial = "X";
    } else if (task.inspectionTypeTag == "weather") {
      basicData.InspectionWeather = "X";
    } else {
      basicData.InspectionWeekly = "X";
    }
    return basicData;
  }
  render() {
    const isGaugeValueAvailable = this.localState.issuesData.some((issue) => issue.gaugeValue);
    return (
      <React.Fragment>
        <DefectReportView
          basicData={this.localState.basicData}
          issuesData={this.localState.issuesData}
          assetsData={this.localState.assetsData}
          signatureImage={this.props.signatureImage}
          userName={this.props.userName}
          header={"Line Inspection and Repair Report"}
          displayModified={false}
          InspectionReportType={this.props.InspectionReportType}
          disableRule213Config={this.props.disableRule213}
          workOrderUpdates={this.localState.workOrderUpdates}
          isGaugeValueAvailable={isGaugeValueAvailable}
        />
      </React.Fragment>
    );
  }
}

export default DefectReport;

export function getWeather(task) {
  let tempUnit = task.tempUnit ? task.tempUnit : "";
  let temp = task.temperature || task.temperature == 0 ? task.temperature + " " + tempUnit : "";
  let weatherVal = task.weatherConditions ? task.weatherConditions : "";
  return temp ? temp + (weatherVal ? ", " + weatherVal : "") : weatherVal ? weatherVal : "";
}

function startEndMP(issue, startField, endField, startPrefix, endPrefix) {
  let start = startField ? issue[startField] : issue.startMp;
  let end = endField ? issue[endField] : issue.endMp;
  let mpVal = startPrefix + start;
  if (end && start !== end) mpVal += " - " + (endPrefix ? endPrefix : "") + end;
  return mpVal;
}

function getCodeDescription(issue, nonFraCode) {
  let codeDescription = {
    majorDefectCode: "",
    minorDefectCode: "",
    majorDescription: "",
    minorDescription: "",
  };
  if (!nonFraCode) {
    let titleIndex = issue.title.indexOf("-");
    if (titleIndex !== -1) {
      codeDescription.majorDefectCode = issue.title.slice(0, titleIndex).split(".")[0] + ".";
      codeDescription.majorDescription = issue.title.slice(titleIndex, issue.title.length);
    } else {
      codeDescription.majorDescription = issue.title;
    }
  }
  let tDescIndex = issue.description.indexOf("-");
  if (tDescIndex !== -1) {
    codeDescription.minorDefectCode = issue.description.slice(0, tDescIndex);
    codeDescription.minorDescription = issue.description.slice(tDescIndex + 1, issue.description.length);
  } else {
    codeDescription.minorDescription = issue.description;
  }
  return codeDescription;
}

function checkInRangeAsset(assetStart, assetEnd, intervalStart, intervalEnd) {
  if (assetStart <= intervalStart && assetEnd >= intervalEnd) {
    return true;
  } else if (assetStart >= intervalStart && assetStart <= intervalEnd) {
    return true;
  } else if (assetEnd >= intervalStart && assetEnd <= intervalEnd) {
    return true;
  } else {
    return false;
  }
}

function considerAssetInInterval(asset, intervalStart, intervalEnd) {
  let assetStart = parseFloat(asset.start) < parseFloat(asset.end) ? asset.start : asset.end;
  let assetEnd = parseFloat(asset.start) > parseFloat(asset.end) ? asset.start : asset.end;
  let inRange = checkInRangeAsset(assetStart, assetEnd, intervalStart, intervalEnd);
  return inRange;
}

function returnMarkerOrMP(object, markers, objectStartEnd, unitMpStartEnd, prefixStartEnd) {
  console.log(object, "object");
  console.log(unitMpStartEnd, "unitMpStartEnd");
  if (markers.startMarker || markers.endMarker) setMarkerValues(object, markers, objectStartEnd);
  else if (objectStartEnd.end) setMPValuesStartEnd(object, objectStartEnd, unitMpStartEnd, prefixStartEnd);
  else setIssueMPValue(object, objectStartEnd, unitMpStartEnd, prefixStartEnd);
}
function setMarkerValues(object, markers, objectStartEnd) {
  object[objectStartEnd.start] = markers.startMarker;
  objectStartEnd.end
    ? (object[objectStartEnd.end] = markers.endMarker)
    : (object[objectStartEnd.start] = `${markers.startMarker} ${markers.startMarker && markers.endMarker ? "-" : ""} ${markers.endMarker}`);
}

function setMPValuesStartEnd(object, objectStartEnd, unitMpStartEnd, prefixStartEnd) {
  object[objectStartEnd.start] = prefixStartEnd.start + unitMpStartEnd.start;
  object[objectStartEnd.end] = prefixStartEnd.end + unitMpStartEnd.end;
}

function setIssueMPValue(object, objectStartEnd, unitMpStartEnd, prefixStartEnd) {
  let addDash = unitMpStartEnd.start && unitMpStartEnd.end ? " - " : "";
  object[objectStartEnd.start] = prefixStartEnd.start + unitMpStartEnd.start + addDash + prefixStartEnd.end + unitMpStartEnd.end;
}



// WEBPACK FOOTER //
// ./src/components/Reports/Timps/LineInspection/DefectReport.jsx